import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Berhenti Merokok";
const DESCRIPTION = "Temukan manfaat berhenti merokok dan seberapa besar peningkatan kesehatan Anda";
const KEYWORDS = "merokok, berhenti merokok, kesehatan";
const OG_URL =
  "https://do-calculate.com/calculator/id/smoking-recovery-calculator/";
function SmokingRecoveryCalculator() {
  const [smokePerDay, setSmokePerDay] = useState(0);
  const [smokingDuration, setSmokingDuration] = useState(0);
  const [quitDate, setQuitDate] = useState(new Date());
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const indonesianWeekdays = [
    "Minggu",
    "Senin",
    "Selasa",
    "Rabu",
    "Kamis",
    "Jumat",
    "Sabtu",
  ];
  const formatDate = (date) => {
    const day = indonesianWeekdays[date.getDay()];
    const month = date.getMonth() + 1;
    const dayOfMonth = date.getDate();
    const year = date.getFullYear();
    return `${day}, ${dayOfMonth}-${month}-${year}`;
  };
  const handleCalculate = () => {
    try {
      const cigarettesPerDay = parseInt(smokePerDay);
      const lifeGain = Math.floor((cigarettesPerDay / 10) * 5);
      const heartRateDropDate = new Date(quitDate);
      heartRateDropDate.setDate(quitDate.getDate() + 1);
      const anxietyDate = new Date(heartRateDropDate);
      anxietyDate.setDate(heartRateDropDate.getDate() + 2);
      const symptomsDiminishDate = new Date(anxietyDate);
      symptomsDiminishDate.setDate(anxietyDate.getDate() + 14);
      const symptomsDisappearDate = new Date(symptomsDiminishDate);
      symptomsDisappearDate.setDate(symptomsDiminishDate.getDate() + 14);
      setResult({
        lifeGain,
        heartRateDropDate: formatDate(heartRateDropDate),
        anxietyDate: formatDate(anxietyDate),
        symptomsDiminishDate: formatDate(symptomsDiminishDate),
        symptomsDisappearDate: formatDate(symptomsDisappearDate),
      });
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini membantu Anda mengetahui manfaat kesehatan dari berhenti merokok
                </p>
                <p>
                  Temukan harta karun kesehatan tersembunyi Anda! Ingin tahu manfaat nyata dari berhenti merokok? Kalkulator ini membantu Anda menjelajahi peningkatan luar biasa yang akan terjadi pada tubuh dan pikiran Anda. Setelah berhenti merokok, Anda akan melihat penurunan signifikan dalam detak jantung dan peningkatan tingkat kecemasan, serta manfaat kesehatan umum lainnya. Mulailah perjalanan pemulihan kesehatan Anda hari ini!
                </p>
                <p>
                  Apakah Anda siap menikmati hidup yang lebih sehat dan bahagia? Berhenti merokok adalah langkah pertama menuju itu. Anda akan melihat peningkatan signifikan dalam kesehatan Anda secara keseluruhan, termasuk peningkatan energi dan pernapasan yang lebih baik. Gunakan kalkulator ini untuk memperkirakan manfaat kesehatan yang akan Anda peroleh. Ingat, Anda tidak sendirian, dan ada banyak orang yang ingin membantu Anda.
                </p>
                <p>
                  <b>
                    Penting: Harap diingat bahwa kalkulator ini hanya alat bantu, dan hasilnya dapat bervariasi dari satu orang ke orang lain. Jika Anda ingin informasi lebih rinci, Anda harus berkonsultasi dengan dokter atau spesialis kesehatan.
                  </b>
                </p>
                <p>
                  {" "}
                  Kalkulator ini dikembangkan berdasarkan{" "}
                  <a
                    href="https://academic.oup.com/ntr/article/9/3/315/1100099"
                    rel="nofollow"
                  >
                    Oxford Academic
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="dose">
                        Jumlah rokok per hari
                      </label>
                      <input
                        id="dose"
                        type="number"
                        value={smokePerDay}
                        onChange={(e) => setSmokePerDay(e.target.value)}
                        placeholder="Masukkan jumlah rokok"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="numberOfTimes"
                      >
                        Durasi merokok (tahun)
                      </label>
                      <input
                        id="numberOfTimes"
                        type="number"
                        value={smokingDuration}
                        onChange={(e) => setSmokingDuration(e.target.value)}
                        placeholder="Masukkan durasi merokok"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="date">
                        Tanggal berhenti
                      </label>
                      <input
                        id="date"
                        type="date"
                        value={quitDate.toISOString().substring(0, 10)}
                        onChange={(e) => setQuitDate(new Date(e.target.value))}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">
                        Tahun yang diperoleh: {result.lifeGain} tahun
                      </p>
                      <p className="text-white">
                        Detak jantung menurun pada: {result.heartRateDropDate}
                      </p>
                      <p className="text-white">
                        Kecemasan muncul pada: {result.anxietyDate}
                      </p>
                      <p className="text-white">
                        Gejala berkurang pada: {result.symptomsDiminishDate}
                      </p>
                      <p className="text-white">
                        Gejala hilang sepenuhnya pada: {result.symptomsDisappearDate}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Detail Lebih Lanjut</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pemulihan dari Merokok</h2>{" "}
                  </u>
                  <p>
                    Berhenti merokok dapat menambah tahun kehidupan Anda dan secara signifikan meningkatkan kesehatan Anda.
                  </p>
                  <div className="p-3 mb-2 bg-info ">
                    Dapat meningkatkan kesehatan jantung dan paru-paru
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Manfaat Awal Berhenti
                    </h2>{" "}
                  </u>
                  <p>
                    Dalam 24 jam setelah berhenti merokok, tubuh mulai pulih. Detak jantung menurun, dan kadar oksigen darah meningkat. Indera penciuman dan perasa mulai membaik dalam hitungan hari.
                  </p>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Setahun Setelah Berhenti</h2>{" "}
                  </u>
                  <p>
                    Setelah satu tahun berhenti merokok, fungsi paru-paru membaik, dan tingkat penyakit jantung menurun. Kemampuan fisik meningkat, dan Anda merasa bernapas menjadi lebih mudah.
                  </p>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Manfaat Jangka Panjang</h2>{" "}
                  </u>
                  <p>
                    Setelah 10 tahun berhenti, risiko kanker paru-paru turun 50%. Dan setelah 15 tahun, risiko penyakit jantung mirip dengan bukan perokok.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SmokingRecoveryCalculator;